import {
  Outlet, useOutletContext,
} from 'react-router-dom';
import { RoutingContextType } from '.';
import { ProductsProvider } from '../contexts';

export function ProductRoutes() {
  const outletValue: RoutingContextType = useOutletContext();
  const contextValue: RoutingContextType = {
    ...outletValue,
  };

  return (
    <ProductsProvider>
      <Outlet context={contextValue} />
    </ProductsProvider>
  );
}
